export const WEB_COMPONENT_NAME = "@corti/ambient-web";
export const WEB_COMPONENT_VERSION = "0.9.0";
